<template>
  <el-image
    data-image
    :src="thumbnail"
    class="tw-cursor-pointer"
    @click="handleClick"
  >
    <template #error>
      <AppImageError @click="handleClick" />
    </template>
  </el-image>
</template>

<script setup lang="ts">
import AppImageError from '@shared/components/AppImageError.vue'

const props = defineProps<{
  thumbnail: string
  link: string
  title: string
}>()

const handleClick = () => {
  window.open(props.link, '_blank')
}
</script>
